import React from 'react';
import "./AboutUs.css";
import AboutUsCards from '../../reuseableComponents/Cards/AboutUsCards';
import Cover from "../../assets/AboutUs/cover.jpg";
import inn from "../../assets/AboutUs/in.png";
import ad from "../../assets/AboutUs/ad.png";
import tr from "../../assets/AboutUs/tr.png";
import HeadingNDescription from '../../reuseableComponents/headingNDescription/headingNDescription';

const AboutUs = () => {
    const items = [
        {
            image: inn,
            heading: "Empowering You with the Information You Need",
            direction: 0,
            description: "The real estate market in the Dominican Republic can be challenging to navigate without the right information. Rentay addresses this need by providing essential data on property prices, neighborhood details, and more, giving you the confidence to make well-informed decisions."
        }, {
            image: tr,
            heading: "A Hassle-Free Experience for Everyone",
            direction: 1,
            description: "At Rentay, we’re committed to offering a seamless and hassle-free experience for all our users. Our intuitive tools, such as interactive maps and property comparison features, make it easier to explore, evaluate, and choose the best options for you. Our platform is designed for anyone looking to rent, buy, or sell a property in the Dominican Republic, simplifying the process as much as possible.  "
        }, {
            image: ad,
            heading: "Cutting-Edge Technology for the Modern Real Estate Market",
            direction: 0,
            description: "To bring a modern touch to the real estate market, Rentay incorporates cutting-edge technology. It allows you to explore properties from the comfort of your home, while our loan calculator helps you make confident financial decisions. Additionally, our direct messaging feature connects you with agents and property owners, ensuring seamless communication and support.  \n" +
                "\n" +
                "At Rentay, we’re here to make every step of your real estate journey easier, faster, and better informed. Discover your next home with Rentay—where finding a property in the Dominican Republic is just a few clicks away."
        }
    ]
    return <div className={"aboutUsConatainer"}>
        <div className={"hero_section"}>
            <div className={"hero_section_container"} data-aos="fade-up">
                <h1 style={{
                    color: "white"
                }}>About Rentay</h1>
                <p style={{
                    color: "white"
                }}>“ Connecting People with Their Dream Homes in the Dominican Republic ”</p>
                <br/>
                <br/>
                <br/>
                {/*<ButtonsComponent/>*/}
            </div>
            <img style={{
                objectFit: "cover"
            }} src={Cover} alt="cover"/>
        </div>
        <br/>
        <br/>
        <br/>
        <br/>
        <div style={{
            width: "90%",
            margin: "auto"
        }}>
            <HeadingNDescription
                style={{
                    marginTop: "5%",
                    fontSize: 20
                }}
                heading={""}
                description={"Rentay is a platform dedicated to bringing together people looking to sell, rent, or buy a property in the Dominican Republic. We believe finding a home should be a simple and user-friendly experience, and we’re here to make that a reality. With Rentay, you can easily list your property if you’re interested in selling or find the perfect home if you’re looking to rent or buy.  \n" +
                    "\n" +
                    "Our mission is simple yet powerful: to empower people with the tools and information they need to make the best decisions in their property search. Whether you’re a first-time buyer, an experienced investor, or someone looking for a place to rent, Rentay is here to guide you every step of the way.  "}/>
        </div>

        <div style={{
            width: "90%",
            margin: "auto"
        }}>
            <HeadingNDescription
                style={{
                    marginTop: "5%"
                }}
                heading={"Why Rentay?  "}
                description={"Rentay is transforming the real estate experience in the Dominican Republic by making property transactions more accessible, transparent, and efficient. Whether you’re looking to rent, buy, or sell, Rentay provides the tools and insights you need to make informed decisions."}/>
        </div>
        <br/>
        <br/>
        <br/>
        {
            items.map((item, idx) => <AboutUsCards
                    title={item.heading}
                    description={item.description}
                    image={item.image}
                    direction={item.direction}
                    index={idx}
                />
            )
        }
        <br/>
        <br/>
        <br/>
        {/*<div style={{*/}
        {/*    width: "90%",*/}
        {/*    margin: "auto"*/}
        {/*}}>*/}
        {/*    <HeadingNDescription*/}
        {/*        style={{*/}
        {/*            marginTop: "5%"*/}
        {/*        }}*/}
        {/*        heading={"Our Team"}*/}
        {/*        description={"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,"}/>*/}
        {/*</div>*/}
        {/*<br/>*/}

        {/*<div className={"teamContainer"}>*/}
        {/*    {*/}
        {/*        team.map(item => <TeamCard name={item.name} position={item.position} image={item.image}/>)*/}
        {/*    }*/}
        {/*</div>*/}
        <br/>
        <br/>
    </div>
}

export default AboutUs